import React from 'react';
import { testimonials } from '../data/content';
export function Testimonials() {
  // Hidden until authentic SCIENCES PRÊTES reviews are added in data/content.ts
  if (testimonials.length === 0) return null;
  return <section className="w-full border-t border-ink/10 bg-paper px-8 py-24 sm:px-14 sm:py-32" data-id="element-208" data-mp="3fym8yp543a6g">
      <div className="mx-auto max-w-6xl" data-id="element-209" data-mp="3azje1xiuikc7">
        <h2 className="font-display text-[2.6rem] leading-[1.02] tracking-tight text-ink sm:text-6xl" data-id="element-210" data-mp="3ayhxjdj295n3">
          Ce qu’en disent <em className="text-pen" data-id="element-211" data-mp="32060otrlpbm7">les enseignants</em>
        </h2>

        <div className="mt-14 grid gap-10 border-t border-ink/15 pt-10 sm:grid-cols-3" data-id="element-212" data-mp="31yl8hasre4ri">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col" data-id="element-213" data-mp="2s1yloggvh3mu">
              <div className="text-sm text-amber-500" aria-label="5 étoiles sur 5" data-id="element-214" data-mp="2s3t9q3nfxbv5">
                <span aria-hidden="true" data-id="element-215" data-mp="v8wvafg59ufc">★★★★★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-display text-2xl leading-snug text-ink" data-id="element-216" data-mp="qbesl6sq0bfs">
                «&nbsp;{item.quote}&nbsp;»
              </blockquote>
              <figcaption className="mt-6 text-sm" data-id="element-217" data-mp="m51alq9dz37d">
                <span className="font-semibold text-ink" data-id="element-218" data-mp="m6m9fs2qh8b1">{item.name}</span>
                <span className="text-ink/60" data-id="element-219" data-mp="78k01190tslv"> — {item.location}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}